import { render, staticRenderFns } from "./gameStageBackview.vue?vue&type=template&id=11f42182&scoped=true&"
import script from "./gameStageBackview.vue?vue&type=script&lang=js&"
export * from "./gameStageBackview.vue?vue&type=script&lang=js&"
import style0 from "./gameStageBackview.vue?vue&type=style&index=0&id=11f42182&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f42182",
  null
  
)

export default component.exports